/**
 * Options for a picker: unique, narrowed to those containing `text` (case-insensitive), and ordered so the
 * best match comes first: exact match, then options starting with `text`, then the rest, each alphabetically.
 */
export function filterOptions(options: readonly string[], text?: string | null): string[] {
    const search = (text ?? '').trim().toLowerCase();

    const rank = (option: string): number => {
        const value = option.toLowerCase();
        if (value === search) return 0;
        if (value.startsWith(search)) return 1;
        return 2;
    };

    return [...new Set(options)]
        .filter(option => search === '' || option.toLowerCase().includes(search))
        .sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
}

/**
 * The library filter to restore after a library is added. A filter that is the full name of the added
 * library would only show that name again, so it is cleared.
 */
export function filterAfterAdd(filter: string, addedLibrary?: string): string {
    return filter.trim().toLowerCase() === addedLibrary?.toLowerCase() ? '' : filter;
}
